import React from 'react';
import { Label } from '../../../components/ui/label';
import styles from './DeactivateEmailSmsToggle.module.css';

interface DeactivateEmailSmsToggleProps {
  checked: boolean;
  onChange: (enabled: boolean) => void;
}

export const DeactivateEmailSmsToggle: React.FC<DeactivateEmailSmsToggleProps> = ({
  checked,
  onChange,
}) => {
  return (
    <div className={styles.deactivateEmailSmsToggle}>
      <div className={styles.content}>
        <Label htmlFor="show-deactivate-email-sms" className={styles.label}>
          Show Deactivate Email/SMS Button
        </Label>
        <p className={styles.description}>
          Show the deactivation action at the bottom of tenant Engage settings. New partners default to
          enabled.
        </p>
      </div>
      <div className={styles.control}>
        <input
          id="show-deactivate-email-sms"
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          className={styles.checkbox}
        />
      </div>
    </div>
  );
};
